export default __webpack_public_path__ + "static/media/legend.9cc769b5.svg";